import React, { useState, useEffect, useRef } from 'react';

const EditLeaveType = ({ editType, isShow, editInformation, onChangeFunc, saveFunc, toggleFunc}) => {
    const {
      name,
      beforeDay,
      minHours,
      wageTimes,
      leavesDay,
      deLeaveAmt,
      approveDay,
      notes,
    } = editInformation;
    const [errors,setErrors] = useState ({});
    const [fields, setFields] = useState ({});
    const nameInput = useRef(null);
    const beforeDayInput = useRef(null);
  const handleValidation = ()=>{
    let errors = {};
    let formIsValid = true;

    //Name
    if(!nameInput){
       formIsValid = false;
       errors["name"] = "Cannot be empty";
    }

    //Email
    if(!beforeDayInput){
       formIsValid = false;
       errors["beforeDay"] = "Cannot be empty";
    }

   setErrors(errors);
   alert(errors)
   return formIsValid;
}

  return (
    <div className="u-editblock fadeIn" style={{height:'1000px',display: isShow === true ? 'flex' : 'none'}}>
      <div className="form-block" style={{width: '360px', top:'30%'}}>
        <div className="u-small-title">{editType === 'EDIT'?'編輯假別':'新增假別'}</div>
        <form className="u-form">
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">假別名稱<span style={{color:'red'}}>*</span>：</label>
              <input ref={nameInput} type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('name', e);}} value={name || ''}/>
            </div>
          </div>
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">規定提前請假天數<span style={{color:'red'}}>*</span>：</label>
              <input ref={beforeDayInput} type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('beforeDay', e);}} value={beforeDay ||''}/>
            </div>
          </div>
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">請假最小單位(小時)<span style={{color:'red'}}>*</span>：</label>
              <input type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('minHours', e);}} value={minHours ||''}/>
            </div>
          </div>
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">扣幾日薪水<span style={{color:'red'}}>*</span>：</label>
              <input type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('wageTimes', e);}} value={wageTimes ||''}/>
            </div>
          </div>
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">給假天數：</label>
              <input type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('leavesDay', e);}} value={leavesDay ||''}/>
            </div>
          </div>
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">全勤扣款金額<span style={{color:'red'}}>*</span>：</label>
              <input type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('deLeaveAmt', e);}} value={deLeaveAmt ||''}/>
            </div>
          </div>
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">簽核時限(天)<span style={{color:'red'}}>*</span>：</label>
              <input type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('approveDay', e);}} value={approveDay ||''}/>
            </div>
          </div>
          <div className="row">              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">備註：</label>
              <input type="text" className="u-form__input underline" onChange={(e)=>{onChangeFunc('notes', e);}} value={notes ||''}/>
            </div>
            <span style={{color:'red'}}>不可超過50個字</span>
          </div>
          <div className="u-btn-group right">
            <button className="btn btn-md save" onClick={(e) => {
              e.preventDefault();
              
              if(handleValidation){
                saveFunc();
              }
            }}>儲存</button>
            <button className="btn btn-md cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleFunc();
              }
            }>取消</button>
          </div>
        </form>
      </div>
    </div>
  )

}

export default EditLeaveType;